import React, { useContext } from 'react';

import Controls from './Controls';
import Integrations from 'src/presentation/components/pages/sidekick/threads/components/Integrations/Integrations';
import SidePanelHeader from './SidePanelHeader';
import { ThreadModuleContext } from './ThreadModuleContext';

function ModuleForm() {
  const { module, moduleSpec } = useContext(ThreadModuleContext);

  if (!module || !moduleSpec) {
    return null;
  }

  const controlCategorySpecs = moduleSpec.controlCategories;

  return (
    <>
      <SidePanelHeader isModule spec={moduleSpec} />
      <Integrations spec={moduleSpec} />
      <Controls controlCategorySpecs={controlCategorySpecs} />
    </>
  );
}

export default ModuleForm;
